(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4892],{

/***/ 8152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/gallery",
      function () {
        return __webpack_require__(6282);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2879);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3955);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1914);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9741);
/* harmony import */ var _LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8506);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











function SectionGallery(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color, _limit = param.limit, limit = _limit === void 0 ? 4 : _limit, slug = param.slug, id = param.id, _type = param.type, type = _type === void 0 ? "hotels" : _type;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), data = ref2[0], setData = ref2[1];
    var ref3 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useFetchSWRv2 */ .bX)(type, {
        _ID: id,
        cct_status: "publish"
    }), 3), hotels = ref3[0], isLoading = ref3[1], isError = ref3[2];
    var limitParam = type == "dining" ? 4 : limit !== null && limit !== void 0 ? limit : 12;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(limitParam), limitCount = ref4[0], setLimitCount = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var temp;
        if (type == "hotels" && hotels && hotels[0].hotel_gallery && hotels[0].hotel_gallery.length > 0) {
            temp = _toConsumableArray(hotels[0].hotel_gallery);
            if (limitCount) {
                temp = temp.slice(0, limitCount);
            }
        } else if (type == "dining" && hotels && hotels[0].gallery && hotels[0].gallery.length > 0) {
            temp = _toConsumableArray(hotels[0].gallery);
            if (limitCount) {
                temp = temp.slice(0, limitCount);
            }
        }
        setData(temp);
    }, [
        hotels,
        limit,
        limitCount
    ]);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), imgSrc = ref6[0], setImgSrc = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isModalOpen = ref7[0], setIsModalOpen = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), photoIdx = ref8[0], setPhotoIdx = ref8[1];
    // useOutsideClick({
    //   ref: ref,
    //   handler: () => setIsModalOpen(false),
    // });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                bg: "white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        mb: 2,
                        as: "h2",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        color: color,
                        children: router.locale == "id" ? "Galeri" : "Gallery"
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}) : data && data.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SimpleGrid */ .MIq, {
                        columns: [
                            2,
                            3,
                            4
                        ],
                        spacing: [
                            4,
                            4,
                            6,
                            6,
                            8
                        ],
                        children: data.map(function(img, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AspectRatio */ .oM5, {
                                ratio: 1,
                                bg: "".concat(color, "40"),
                                cursor: "pointer",
                                onClick: function() {
                                    setPhotoIdx(i);
                                    setImgSrc((0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .convertImgHttps */ .Nu)(img.url));
                                    setIsModalOpen(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .convertImgHttps */ .Nu)(img.url),
                                    alt: "gallery image ".concat(i + 1),
                                    objectFit: "cover",
                                    h: "100%",
                                    w: "100%",
                                    loading: "lazy"
                                })
                            }, img.id);
                        })
                    }),
                    hotels && hotels.length > 0 && (hotels[0].hotel_gallery || hotels[0].gallery) && (limitCount < ((ref = hotels[0].hotel_gallery) === null || ref === void 0 ? void 0 : ref.length) || limitCount < ((ref1 = hotels[0].gallery) === null || ref1 === void 0 ? void 0 : ref1.length)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                        mt: limit == null ? _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_9__/* .safeMarginX */ .Mp : 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            variant: "dark",
                            bg: color,
                            _hover: {
                                bg: "white",
                                color: color,
                                borderColor: color,
                                borderWidth: 1
                            },
                            borderColor: color,
                            onClick: function() {
                                if (limit == null) {
                                    setLimitCount(limitCount + (type == "dining" ? 4 : 12));
                                } else {
                                    router.push(slug ? "/".concat(slug, "/gallery") : "/gallery");
                                }
                            },
                            children: router.locale == "id" ? "Lebih Banyak" : "See More"
                        })
                    })
                ]
            }),
            isModalOpen && data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainSrc: data[photoIdx].url,
                nextSrc: data[(photoIdx + 1) % data.length],
                prevSrc: data[(photoIdx + data.length - 1) % data.length],
                onCloseRequest: function() {
                    return setIsModalOpen(false);
                },
                onMovePrevRequest: function() {
                    return setPhotoIdx((photoIdx + data.length - 1) % data.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIdx((photoIdx + 1) % data.length);
                }
            })
        ]
    });
};


/***/ }),

/***/ 6282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ GalleryPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var _components_SectionGallery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2493);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4850);






var __N_SSG = true;
function GalleryPage(param) {
    var header = param.header, hotelBrands = param.hotelBrands;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: "Gallery - ".concat(header.name, " | Parador Hotels & Resorts")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionGallery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                limit: null,
                color: header.color_primary,
                id: header.id,
                slug: header.slug
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: header.color_primary,
                color: "white",
                logo: header.logo_light,
                hotelSlug: header.slug
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,9392,4939,8078,9774,2888,179], function() { return __webpack_exec__(8152); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);